/**
 * Robots meta tag options
 */
export enum RobotsTagOptions {
  noIndex = "noindex",
  noFollow = "nofollow",
  index = "index",
  follow = "follow"
}